import { render, staticRenderFns } from "./RegisterIntegratePage.vue?vue&type=template&id=0023ebd8&scoped=true&"
import script from "./RegisterIntegratePage.vue?vue&type=script&lang=js&"
export * from "./RegisterIntegratePage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterIntegratePage.vue?vue&type=style&index=0&id=0023ebd8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023ebd8",
  null
  
)

export default component.exports